import useFetchObjects from "../../api/useFetchObjects";

const useCurrentSubscription = () => {
  return useFetchObjects(
    ["current-subscription"],
    "subscriptions/current/",
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: true, // Keep subscription status up to date
      enabled: !!localStorage.getItem("token"), // Only fetch if user is logged in
    },
  );
};

export default useCurrentSubscription;
